import axios from 'axios';

const AUTH_BASE_URL = 'https://auth-api.cloud-interview.in';
const BLOG_BASE_URL = 'https://blog-api.cloud-interview.in';
const COURSE_REG_URL = `https://course-reg.doubledigit-solutions.com`;

export const authAPI = axios.create({
  baseURL: AUTH_BASE_URL,
});

export const blogAPI = axios.create({
  baseURL: BLOG_BASE_URL,
});

export const axiosAuthAPIPrivate = axios.create({
  baseURL: AUTH_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const axiosBlogAPIPrivate = axios.create({
  baseURL: BLOG_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const courseRegAPI = axios.create({
  baseURL: COURSE_REG_URL,
});

